import Component from '@apps-pages/delayed/component';
/**
 * @import internal modules
 */
import {DelayedActionCreator } from "@apps-store/action-creator";

/**
 * @import external modules
 */

import * as React from "react";
import { connect } from "react-redux";
import { Dispatch , bindActionCreators } from "redux";
import * as Lodash from 'lodash';


class Container extends React.PureComponent<any, any> {
    /**
     * @public
     * @constructor
     * @param { any } props 
     * @return { }
     */
    public constructor(props: any){

        super(props);

        this.state = { content: [] , loadingState:false };
       
    }
    /**
     * Cycle de vie de React : componentDidMount
     * @public
     * @method componentDidMount
     * @param {}
     * @return { any }
     */
    public componentDidMount = () => {

        this.setState({loading: true , loadingState:false})

        this.props.DelayedActionCreator(1)
        
    }
    /**
     * Cycle de vie React : componentWillReceiveProps
     * @public
     * @method componentWillReceiveProps
     * @param { any  }  nextProps
     * @return {any }
     */
    public componentWillReceiveProps = (nextProps: any) =>{
        
        if(nextProps.error !== this.props.error){ 
            if(!Lodash.isUndefined(nextProps.error)){

                this.setState({errorState : nextProps.error})

            }
        }
        
        else if(nextProps.data !== this.props.data){

            this.setState({content : nextProps.data})
       
        }else if(nextProps.loading !== this.props.loading){

            if(!Lodash.isUndefined(nextProps.loading)){

                this.setState({loadingState : nextProps.loading})

            }

        }
    }   
    /**
     * Cycle de vie de React : render
     * @public
     * @method render
     * @param {}
     * @return { any }
     */
    public render() {
      
        return <Component {...this.props} {...this.state} />
    }
}

/**
 * @function mapStateToProps
 * @param { any }  state 
 * @return { any }
 */
const mapStateToProps = (state : any) => ({ data:state.delayed.data , error:state.delayed.error, loading:state.delayed.loading });


const mapDispatchToProps = (dispatch : Dispatch) =>
    bindActionCreators({
        DelayedActionCreator
    }, dispatch);


export default connect(mapStateToProps,mapDispatchToProps)(Container);







// WEBPACK FOOTER //
// ./src/apps/components/@pages/delayed/container.tsx